export default __webpack_public_path__ + "img/2_4-ad3d6b86.png";